import { useCallback } from "react";

import toast from "react-hot-toast";

import styled from "styled-components";

import { Button } from "simplydo/react/ui";

import api from "api";

import type { NotificationContentProps } from "../../types";

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const JoinRequestedActions = ({
  events = [],
  invitations = [],
  onAccept,
  onReject,
}: NotificationContentProps) => {
  const invitationId = events[0]?.invitation;
  const invitationExists =
    invitationId ?
      invitations.find((i) => i._id === invitationId && !i.acceptedAt)
    : undefined;

  const acceptInvite = useCallback(() => {
    if (!invitationId) return;
    api.invitations.accept(
      invitationId,
      () => {
        onAccept?.(invitationId);
        toast.success("Request accepted");
      },
      (err) => {
        toast.error(err.message);
      },
    );
  }, [invitationId, onAccept]);

  const rejectInvite = useCallback(() => {
    if (!invitationId) return;
    api.invitations.reject(
      invitationId,
      () => {
        onReject?.(invitationId);
        toast.success("Request rejected");
      },
      (err) => {
        toast.error(err.message);
      },
    );
  }, [invitationId, onReject]);

  if (!invitationExists) return null;
  return (
    <ButtonContainer>
      <Button
        icon="check"
        color="green"
        basic
        size="small"
        onClick={acceptInvite}
        style={{ marginBottom: 5 }}
      />
      <Button basic icon="trash" size="small" onClick={rejectInvite} />
    </ButtonContainer>
  );
};

export default JoinRequestedActions;
